import { render, staticRenderFns } from "./ContentTopics.vue?vue&type=template&id=2cf37b94"
import script from "./ContentTopics.vue?vue&type=script&lang=js"
export * from "./ContentTopics.vue?vue&type=script&lang=js"
import style0 from "./ContentTopics.vue?vue&type=style&index=0&id=2cf37b94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports